import { Component, Input, Inject } from "@angular/core";
import { SideEffect, InvokeTransitionOnOtherWorkflowConfig } from "../../../../common/models/flow.dto";
import { SideEffectData, SIDE_EFFECT_DATA_TOKEN } from "./models/types";

@Component({
    selector: "side-effect-invoke-transition",
    templateUrl: "./side-effect-invoke-transition.component.html",
    standalone: false
})
export class SideEffectInvokeTransition {
    public _sideEffect: SideEffect;

    get conf(): InvokeTransitionOnOtherWorkflowConfig {
        const config = this._sideEffect.configuration as InvokeTransitionOnOtherWorkflowConfig;
        return config;
    }

    set sideEffect(value: SideEffect) {
        this._sideEffect = value;

        if (!this.sideEffect.configuration)
            this._sideEffect.configuration = {};

        this._fixConfig(this._sideEffect.configuration);
    }

    get sideEffect(): SideEffect {
        return this._sideEffect;
    }

    constructor(@Inject(SIDE_EFFECT_DATA_TOKEN) public data: SideEffectData) {
        this.sideEffect = data.sideEffect;
    }

    public _fixConfig(seconf: any): void {
        if (seconf.otherWorkflowIdRule === undefined) {
            seconf.otherWorkflowIdRule = "";
        }

        if (seconf.otherWorkflowTransitionRule === undefined) {
            seconf.otherWorkflowTransitionRule = "";
        }

        if (seconf.otherWorkflowContextShouldInvokeRule === undefined) {
            seconf.otherWorkflowContextShouldInvokeRule = "";
        }
    }
}

